var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M12.381 13.722L7.002 8.344l-5.376 5.377a.95.95 0 01-1.344 0 .95.95 0 010-1.343l5.377-5.377L.282 1.623a.95.95 0 010-1.343.95.95 0 011.344 0l5.377 5.378L12.381.28a.951.951 0 011.343 0 .95.95 0 010 1.343L8.346 7l5.378 5.377a.95.95 0 01.279.673.95.95 0 01-.279.673.951.951 0 01-.671.277.95.95 0 01-.672-.277z"
  })));
}
export default SvgCloseModal;